import React, { useState } from "react";
import Topbar from "../Topbar/Topbar";
import ProfileNavBar from "../ProfileNavbar";
import { Outlet } from "react-router-dom";

const Layout = () => {
  const [roleText, setRoleText] = useState("");
  return (
    <div className="">
      <Topbar roleText={roleText} setRoleText={setRoleText} />
      <div className="dashboard">
        <ProfileNavBar setRoleText={setRoleText} />
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
